import { render, staticRenderFns } from "./AderenciaSugestaoCompra.vue?vue&type=template&id=50de57be&scoped=true"
import script from "./AderenciaSugestaoCompra.vue?vue&type=script&lang=js"
export * from "./AderenciaSugestaoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de57be",
  null
  
)

export default component.exports